import React, { useContext, useState, useEffect } from 'react';
import { Box, CardProduct, Text } from '../../../../components';
import styles from '../../Summary.module.css';
import {
  productFutura1x,
  productFutura2x,
  productFutura3x,
} from '../../../../assets/images/Global';
import PaymentContext from '../../../../context/Payment/Context';
import useProductDataByCountry from '../../../../hooks/useProductDataByCountry';
import ProductContext from '../../../../context/Product/Context';
import Coupon from '../Coupon';
import convertPrice from '../../../../hooks/convertPrice';
import GlobalContext from '../../../../context/Global/Context';
import Constants from '../../../../utils/Constants';
import { availableCountries } from '../../../../utils/locale';
import { getTotalPrice } from '../../../../utils/cardForm';

const ResumeModalMobile = () => {
  const paymentContext = useContext(PaymentContext);
  const productContext = useContext(ProductContext);
  const globalContext = useContext(GlobalContext);
  const {
    productsMobile,
    showHideProductsMobile,
  } = paymentContext;
  const { order, products, carts } = productContext;
  const {
    isCitaFlow,
    appointmentCenter,
    appointmentDate,
    isOnlySettlement,
    isOnlyAdvance,
    isOnlyComplementaryPayment,
    country,
  } = globalContext;
  const [productsList, setProductsList] = useState([]);
  const [originalPrice, setOriginalPrice] = useState(0);
  const [showProducts, setShowProducts] = useState(false);
  const [productQuantity, setProductQuantity] = useState(0);
  const [showDelivery, setShowDelivery] = useState(false);
  const { assetsURL } = Constants;
  const chevronSvg = `${assetsURL}/svg/chevron-blue.svg`;
  const carSvg = `${assetsURL}/svg/car-blue.svg`;

  const { lineItems = [] } = carts[0];
  let cost = 0;
  let quantity = 0;
  if (productsList.length < products.length) {
    const converted = useProductDataByCountry(products, true, true);
    setProductsList(converted);
  }
  const hasShipping = lineItems.some((item) => { return item.productKey === 'shipping'; });
  useEffect(() => {
    lineItems.forEach((item) => {
      if (item.price.discounted) {
        cost = +cost + (item.price.discounted.value.centAmount / 100) * item.quantity;
      } else {
        cost = +cost + (item.price.value.centAmount / 100) * item.quantity;
      }
      quantity += item.quantity;
      const priceConv = convertPrice(Number(originalPrice + cost).toFixed(2));
      setOriginalPrice(priceConv);
    });
    setProductQuantity(quantity);
  }, []);

  useEffect(() => {
    if (isCitaFlow || isOnlySettlement || isOnlyAdvance || isOnlyComplementaryPayment) {
      setShowDelivery(false);
    }
  }, [isCitaFlow, isOnlySettlement, isOnlyAdvance, isOnlyComplementaryPayment]);

  return (
    <>
      <div className={styles.topContainer}>
        <button type="button" className={styles.collapButton} onClick={() => { setShowProducts(!showProducts); }}>
          <img width={26} height={26} src={carSvg} alt="car" />
          <span className={styles.productQuantity}>{productQuantity}</span>
          <span className={styles.collapTitle}>{showProducts ? 'Ocultar carrito' : 'Ver carrito'}</span>
          <img width={24} height={24} src={chevronSvg} className={showProducts ? styles.chevron : ''} alt="Chevron" />
        </button>
        <span className={styles.totalPrice}>
          {country.toLocaleLowerCase() !== 'pe' ? '$' : 'S/ '}
          {getTotalPrice(paymentContext, country)}
          {' '}
          {availableCountries[country.toLocaleLowerCase()].currency}
        </span>
      </div>
      <div className={showProducts ? styles.expanded : styles.collapsed}>
        <div>
          <div className={styles.lineModal} />
          <Box
            p={productsList.length === 1 ? '0 16px 16px 16px' : '0 16px 16px 16px'}
          >
            {!order && productsList.map((product, index) => {
              return (
                <CardProduct
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  img1x={
                    product.images[0] ? product.images[0].url : productFutura1x
                  }
                  img2x={
                    product.images[1] ? product.images[1].url : productFutura2x
                  }
                  img3x={
                    product.images[2] ? product.images[2].url : productFutura3x
                  }
                  title={product.name}
                  principalPrice={getTotalPrice(
                    paymentContext,
                    country,
                  )}
                  quantity={product.quantity}
                  unitPrice={product.totalPrice}
                  secondaryPrice={`${country.toLocaleLowerCase() !== 'pe' ? '$' : 'S/ '}${getTotalPrice(paymentContext, country)} por unidad`}
                  isPromo={product.hasDiscount}
                  isCitaFlow={product.productId === process.env.REACT_APP_CITA_ID && true}
                  appointmentDate={
                    product.productId === process.env.REACT_APP_CITA_ID
                    && appointmentDate
                  }
                  appointmentCenter={
                    product.productId === process.env.REACT_APP_CITA_ID
                    && appointmentCenter
                  }
                  countryCurrency={`${country.toLocaleLowerCase() !== 'pe' ? '$' : 'S/ '}`}
                  variant={product.name === 'Envío' ? '' : product.variant}
                  country={country}
                  hasShipping={hasShipping}
                />
              );
            })}
          </Box>
          <div className={styles.line} />
          <Box p="0 16px 0 16px">
            <Box fd="row" jc="space-between" p="0 0 16px 0">
              <Text c="#757575" f="Inter Regular" s={14} lh={20}>
                Total en tu carrito
              </Text>
              <Text id="Check_Summary_TotalOriginalPrice" c="#757575" f="Inter Regular" s={14} lh={20}>
                {country.toLocaleLowerCase() !== 'pe' ? '$' : 'S/ '}
                {getTotalPrice(paymentContext, country)}
              </Text>
            </Box>
            {showDelivery && (
              <Box fd="row" jc="space-between">
                <Box fd="column" ai="flex-start" p="0 0 16px 0">
                  <Text
                    p="0 0 4px 0"
                    c=" #9E9E9E"
                    f="Inter Regular"
                    s={14}
                    lh={20}
                  >
                    Envío
                  </Text>
                  <Text c="#9E9E9E" f="Inter Regular" s={14} lh={20}>
                    Tiempo aproximado:
                  </Text>
                  <Text c="#9E9E9E" f="Inter Regular" s={14} lh={20}>
                    entre 2 y 5 días hábiles
                  </Text>
                </Box>
                <Text c="#9E9E9E" f="Inter Regular" s={14} lh={20}>
                  Gratis
                </Text>
              </Box>
            )}
            <Coupon />
          </Box>
          <div className={styles.line} />
          <Box p="0 16px 0px 16px">
            <Box fd="row" jc="space-between">
              <Text c="#757575" f="Inter Regular" s={14} lh={20}>
                Total
              </Text>
              <Text id="Check_Summary_TotalWithDiscount" c="#616161" f="Inter Normal" s={20} lh={20}>
                {country.toLocaleLowerCase() !== 'pe' ? '$' : 'S/ '}
                {getTotalPrice(paymentContext, country)}
                {' '}
                {country.toLocaleLowerCase() !== 'pe' ? availableCountries[country.toLocaleLowerCase()].currency : ''}
              </Text>
            </Box>
          </Box>
        </div>
        <button
          id="Check_Summary_CloseProducts_HiddenArea"
          onClick={() => {
            showHideProductsMobile(!productsMobile);
          }}
          type="button"
          aria-label="area"
          className={styles.hiddenButton}
        />
      </div>
    </>
  );
};

export default ResumeModalMobile;
